module.exports = __webpack_public_path__ + "statics/img/2-3.6f46e91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/2-3.png
// module id = hJei
// module chunks = 1